import { SET_PROGRAMMES, SET_PROGRAMME } from '@actions/programme'

const defaultState = {
  programmes: null,
  programme: null,
  total: 0
}

const programmeReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_PROGRAMMES: {
      const { data } = action
      return {
        ...state,
        programmes: data.list,
        total: data.total,
      }
    }
    case SET_PROGRAMME: {
      const { data } = action
      return {
        ...state,
        programme: data
      }
    }
    default:
      return state
  }
}

export default programmeReducer
